module.exports = __webpack_public_path__ + "img/gd.0e96eaa.png";